export default "__VITE_ASSET__8OBGK6Vx__"